// src/components/AdminRoute.js

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const { userRole, currentUser } = useAuth();

  // Permite a entrada se o usuário for 'admin' OU 'OWNER' da PTS
  if (currentUser && userRole !== 'admin' && userRole !== 'OWNER') {
    return <Navigate to="/" />;
  }

  return children;
};

export default AdminRoute;